import { OfferRulesTable } from "components/Tables/OfferRulesTable/OfferRulesTable.tsx";
import { useUser } from "hooks/useUser.ts";
import { FC } from "react";
import { RoleEnum } from "types/enums";

interface RulesSectionProps {
    offerId: string;
}

export const RulesSection: FC<RulesSectionProps> = ({ offerId }) => {
    const userUtils = useUser();

    return (
        <div className="overflow-y-auto">
            <OfferRulesTable
                offerId={offerId}
                readOnly={
                    !userUtils
                        ?.getActiveTenant()
                        ?.userRoles?.some((role) =>
                            [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name)
                        )
                }
            />
        </div>
    );
};
